import { ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, CUSTOM_ELEMENTS_SCHEMA, Input, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReportPlan, ReportPlanInterface } from '../../report-plan';
import { MatButtonModule } from '@angular/material/button';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { CarouselComponent, SwiperItem } from 'src/app/shared/carousel/carousel.component';
import { DeviceService } from 'src/app/services/device.service';

@Component({
  selector: 'promo-features',
  standalone: true,
  imports: [CommonModule,
    TranslateModule,
    SharedModule,
    NgOptimizedImage,
    MatButtonModule,
    CarouselComponent
  ],
  templateUrl: './promo-features.component.html',
  styleUrls: ['./promo-features.component.scss'],
})
export class PromoFeaturesComponent {
  translate_string(feature:string) {
    return 'page.report.features.' + feature
  } 
  // features_keys$ = signal<string[]>([]);
  // featuresBlocks$ = computed(() => this.generate_content());
  @Input() featuresBlock: any[] | SwiperItem[] = [];
  @Input() features:string[] = ['informazioni', 'analisi', 'comparativa', 'strategie', 'indici','trend','governance','conclusioni'];;
  @Input() featureMode: 'carousel' | 'list' = 'list';
  @Input() showFeatures = true;
  @Input() showIntro = true;

  isMobile = signal<boolean>(false);
  
  
  generate_content() {
    let feature: any = [];
    if (!this.features || !this.features.length) return;
    this.features.map((key) => {
      let el:any = {
        title: this.translate_string('title_' + key),
        subtitle: this.translate_string('subtitle_' + key),
        image: '/images/benchmark/'+key+'.webp',
      }
      if (!this.isMobile()) {
        el.content = this.translate_string('content_' + key); 
      }
      return feature.push(el)
    })
    return feature
    }  
      
  constructor(private eventInteractionService: EventInteractionService,
    private changeDetectionRef: ChangeDetectorRef,
    private deviceService: DeviceService
  ) {
      
  }
  ngOnInit() {
    // this.generate_content();
    this.isMobile.set(this.deviceService.is_mobile());
    if (!this.featuresBlock?.length) {
      this.featuresBlock = this.generate_content();   
    }
  
  }


  buyBasicPlan() {
    this.eventInteractionService.publishData({ event: 'addToCart', data: {sku: 'report-digitale-basic'} });  
  }

  showPlans() {
    this.eventInteractionService.publishData({ event: 'scrollToPlans' });
  }
 


}
